/** @format */

import { useForm } from "react-hook-form";
import Tq5Mapper from "../mappers/tq5Mapper";
import { handleNext } from "../../../shared/utils/navigationUtils";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import FormNavigationButtons from "../../../shared/components/FormNavigationButtons";
import QuoteStep from "../enums/QuoteStep";
import VehicleLookupNew from "../../../shared/components/VehicleLookupNew";
import MonthYearField from "../../../shared/components/monthYearField";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";
import { useState } from "react";
import RadioGroup from "../../../shared/components/RadioGroup";

const Tq5 = () => {
  const [errorVR, setErrorVR] = useState(null);

  const formMethods = useForm({
    defaultValues: Tq5Mapper.get(),
  });
  const {
    register,
    formState: { errors, isValid },
    watch,
    setValue,
    control,
    trigger,
    handleSubmit,
  } = formMethods;

  const STATE = useAppStateStore();

  const onSubmit = (data) => {
    const selectedVehicleIndex = watch("setSelectedVehicleIndex");
    const lookupvehicleReg = watch("lookupvehicleReg");
    if (STATE.isManualVehicleEntry && selectedVehicleIndex === null) {
      setErrorVR("Please select a vehicle before proceeding.");
      return;
    }
    if (!STATE.isManualVehicleEntry && (!isValid || !lookupvehicleReg)) {
      setErrorVR("Please lookup registration before proceeding.");
      return;
    }

    if (isValid) {
      TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TQ5_NEXT_CLICKED);
    }
    Tq5Mapper.set(data, STATE);
    handleNext(QuoteStep.TQ6);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <h1 className="margin-bottom-10">Vehicle Details</h1>
        <p className="margin-bottom-30">
          We're almost there—just a few more details to complete your quote.
        </p>
        <div className="fields">
          <VehicleLookupNew
            STATE={STATE}
            formMethods={formMethods}
            errorVR={errorVR}
            setErrorVR={setErrorVR}
          />
          {watch("noMatchedData") === true && (
            <>
              {watch("machedData") === true && (
                <>
                  <RadioGroup
                    name="vehiclePurchased"
                    mainLabel="Have you purchased the vehicle?"
                    register={register}
                    errors={errors.vehiclePurchased}
                    onNo={() => {
                      setValue("purchaseDateMonth", null);
                      setValue("purchaseDateYear", null);
                      setValue("ownedPrevVehicle", null);
                      setValue("prevVehicleRegis", null);
                      setValue("vehRegistration", null);
                      setValue("vehicleModified", "No");
                      setValue("prevLookupVehicleReg", null);
                    }}
                  />
                  {watch("vehiclePurchased") === "Yes" && (
                    <>
                      <MonthYearField
                        label="What date did you purchase the vehicle?"
                        control={control}
                        monthID="purchaseDateMonth"
                        yearID="purchaseDateYear"
                        errors={
                          errors.purchaseDateMonth || errors.purchaseDateYear
                        }
                        trigger={trigger}
                        watch={watch}
                        register={register}
                      />
                    </>
                  )}

                  {watch("datedifference") &&
                    watch("vehiclePurchased") === "Yes" &&
                    (watch("purchaseDateMonth") &&
                      watch("purchaseDateYear")) !== null && (
                      <RadioGroup
                        name="vehRegistration"
                        mainLabel="Do you have the registration of your previous vehicle?"
                        register={register}
                        errors={errors.vehRegistration}
                        onNo={() => {
                          setValue("ownedPrevVehicle", null);
                        }}
                      />
                    )}

                  {watch("vehRegistration") === "Yes" && (
                    <RadioGroup
                      name="ownedPrevVehicle"
                      mainLabel="Did you own the previous vehicle for more than 12 months?"
                      register={register}
                      errors={errors.ownedPrevVehicle}
                    />
                  )}

                  {watch("ownedPrevVehicle") === "Yes" && (
                    <VehicleLookupNew
                      STATE={STATE}
                      prevVeh={true}
                      formMethods={formMethods}
                      errorVR={errorVR}
                      setErrorVR={setErrorVR}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </QuoteFormWrapper>
      <FormNavigationButtons
        prevStep={QuoteStep.TQ4}
        isValid={
          (STATE.isManualVehicleEntry
            ? isValid && watch("setSelectedVehicleIndex") !== null
            : isValid) &&
          watch("lookupvehicleReg") !== null &&
          watch("lookupvehicleReg") !== undefined
        }
      />
    </form>
  );
};

export default Tq5;
